var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRejected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "#F01715"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2071 4.79289C13.5976 5.18342 13.5976 5.81658 13.2071 6.20711L9 10.4142L4.79289 6.20711C4.40237 5.81658 4.40237 5.18342 4.79289 4.79289C5.18342 4.40237 5.81658 4.40237 6.20711 4.79289L9 7.58579L11.7929 4.79289C12.1834 4.40237 12.8166 4.40237 13.2071 4.79289Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79289 13.1212C4.40237 12.7306 4.40237 12.0975 4.79289 11.707L9 7.49985L13.2071 11.707C13.5976 12.0975 13.5976 12.7306 13.2071 13.1212C12.8166 13.5117 12.1834 13.5117 11.7929 13.1212L9 10.3283L6.20711 13.1212C5.81658 13.5117 5.18342 13.5117 4.79289 13.1212Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejected);
export default __webpack_public_path__ + "static/media/rejected.ee5f8421b7c41f0a0bb0052ddb21da3c.svg";
export { ForwardRef as ReactComponent };